import { render, staticRenderFns } from "./RouterForm.vue?vue&type=template&id=57eb4f36&"
import script from "./RouterForm.vue?vue&type=script&lang=js&"
export * from "./RouterForm.vue?vue&type=script&lang=js&"
import style0 from "./RouterForm.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports